<template>
    <section id="page-soorten" class="page">
        <div class="page__content container">
            <!-- Title and buttons -->
            <div class="row">
                <div class="col-12-sm">
                    <h1>Hybride docenten zijn er in allerlei soorten en maten</h1>
                    <p>Dé hybride docent bestaat niet; er zijn talloze combinaties mogelijk. Zie hieronder enkele voorbeelden.</p>
                    <div class="page-soorten__numerator">
                        <div class="page-soorten__numerator-item"
                             v-for="index in 4"
                             v-on:click="selectType(index)"
                             v-bind:class="{'page-soorten__numerator-item--active': index === selectedTypeIndex}"
                             >{{index}}</div>
                    </div>
                    <ul class="page-soorten__type-description">
                        <li><i class="fa fa-arrow-right" aria-hidden="true"></i> {{omgeving2}}</li>
                        <li><i class="fa fa-arrow-right" aria-hidden="true"></i> {{rol2}}</li>
                    </ul>
                </div>
            </div>

            <!-- Omgeving icons -->
            <div class="row">
                <div class="col-5-sm">
                    <p>Baan 1</p>
                    <div class="job-combination job-combination--baan1">
                        <img src="../../assets/images/school90h.png"
                             class="job-combination__building"
                             v-bind:class="firstBaanClass">
                        <img src="../../assets/images/docent-vrouw-100.png"
                             class="job-combination__person"
                             v-bind:class="firstBaanClass">
                    </div>
                </div>
                <div class="col-2-sm">
                    <img class="page-soorten__plus" src="../../assets/icons/plus.svg">
                </div>
                <div class="col-5-sm">
                    <p>Baan 2</p>
                    <div class="job-combination">
                        <img src="../../assets/images/school90h.png" class="job-combination__building"
                            v-bind:class="schoolClass">
                        <img src="../../assets/images/bedrijf90h.png" class="job-combination__building"
                             v-bind:class="bedrijfClass">
                        <img src="../../assets/images/docent-vrouw-100.png"
                             v-bind:class="docentClass"
                             class="job-combination__person">
                        <img src="../../assets/images/niet-docent-vrouw-100.png"
                             v-bind:class="notDocentClass"
                             class="job-combination__person">
                    </div>
                </div>
            </div>

            <!-- Example text and button -->
            <p class="page-soorten__praktijk-header">In de praktijk:</p>
            <div class="row page-soorten__praktijk">
                <div class="col-12-sm">
                    <p class="page-soorten__praktijk-text">{{exampleText}}</p>
                    <div>
                        <quote v-if="selectedTypeIndex===1"
                               :quote="types[1].quote"
                               :img-url="types[1].imgUrl"></quote>
                        <quote v-if="selectedTypeIndex===2"
                               :quote="types[2].quote"
                               :img-url="types[2].imgUrl"></quote>
                        <quote v-if="selectedTypeIndex===3"
                               :quote="types[3].quote"
                               :img-url="types[3].imgUrl"></quote>
                        <quote v-if="selectedTypeIndex===4"
                               :quote="types[4].quote"
                               :img-url="types[4].imgUrl"></quote>
                    </div>
                </div>
            </div>

            <page-next-button v-on:click="nextHandler"></page-next-button>
        </div>
    </section>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .page-soorten__numerator-item
        display inline-block
        padding .5em
        width 2em
        height @width
        font-family $font-button
        cursor pointer
        border 1px solid $color-main-1
        border-right none
        &:last-child
           border-right 1px solid $color-main-1

    .page-soorten__numerator-item--active
        background-color $color-main-1
        color #ffffff

    .page-soorten__counter
        font-size 1em
        border 3px solid $color-main-1
        border-radius 50%
        line-height  1.6em
        width 2em
        height 2em
        text-align center
        display inline-block
        margin-left .5em

    .page-soorten__plus
        width 50px
        margin-top 70px

    .page-soorten__highlight
        border-radius 3px
        display inline-block
        background-color $color-main-1
        color #fff
        padding .1em .25em

    .page-soorten__type-description
        padding 15px
        display inline-block
        li
            list-style none

    .page-soorten__praktijk-header
        margin-bottom .3em

    .page-soorten__praktijk
        border 1px solid
        border-radius 8px
        padding-top 10px

    .page-soorten__result-person
        transform translate(16px, 0)

    .page-soorten__select-docent-text
        float right

</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');

    import quote from '../quote/quote.vue';
    import page from './page';

    export default {
        mixins: [page],
        data() {
            return {
                types: [
                    {
                        text: '',
                        showBaan1: false
                    },
                    {
                        text: 'Hybride docent in <span class="page-soorten__highlight">dezelfde omgeving</span> in een <span class="page-soorten__highlight">vergelijkbare onderwijsrol</span>',
                        showBaan1: true,
                        isSchool: true,
                        isDocent: true,
                        baan2: 'Leraaropleider',
                        omgeving2: 'Vergelijkbare omgevingen',
                        rol2: 'Vergelijkbare rollen',
                        exampleText: 'Denk bijvoorbeeld aan een leraar Nederlands die ook lerarenopleider in het hbo is.',
                        imgUrl: require('../../assets/images/docent-man-100.png'),
                        quote: 'Er is een veel grotere en blijvende kruisbestuiving. De hogeschool waardeert enorm dat je zelf met de poten in de klei staat, dus zelf weet waar je het over hebt.'
                    },
                    {
                        text: 'Hybride docent in <span class="page-soorten__highlight">dezelfde omgeving</span> maar in een <span class="page-soorten__highlight">andere rol</span>',
                        showBaan1: true,
                        isSchool: true,
                        isDocent: false,
                        baan2: 'Onderzoeker',
                        omgeving2: 'Vergelijkbare omgevingen',
                        rol2: 'Verschillende rollen',
                        exampleText: 'Denk bijvoorbeeld aan een leraar natuurkunde die zich daarnaast bezighoudt met gamification in het onderwijs.',
                        imgUrl: require('../../assets/images/docent-onderzoeker-100.png'),
                        quote: 'Mensen weten dat ik naast het lesgeven ook nog zzp’er ben. Vanuit de directie wordt dit heel erg gewaardeerd. Ze weten dat ik zicht op bepaalde dingen heb vanuit mijn rol als docent-trainer. Dat is fijn.'
                    },
                    {
                        text: 'Hybride docent in <span class="page-soorten__highlight">andere omgeving</span> maar in een <span class="page-soorten__highlight">vergelijkbare rol</span>',
                        showBaan1: true,
                        isSchool: false,
                        isDocent: true,
                        baan2: 'Bedrijfstrainer',
                        omgeving2: 'Verschillende omgevingen',
                        rol2: 'Vergelijkbare rol',
                        exampleText: 'Denk bijvoorbeeld aan een leraar economie die daarnaast beleidsmedewerker is bij het ministerie van OC&W.',
                        imgUrl: require('../../assets/images/docent-beleidsmedewerker-100.png'),
                        quote: 'Bekeken vanuit een beleidsfunctie bij het ministerie van OC&W is het werken in het onderwijs "behind enemy lines". En, andersom gezien natuurlijk ook.'
                    },
                    {
                        text: 'Hybride docent in <span class="page-soorten__highlight">andere omgeving</span> in een <span class="page-soorten__highlight">andere rol</span>',
                        showBaan1: true,
                        isSchool: false,
                        isDocent: false,
                        baan2: 'Ondernemer',
                        omgeving2: 'Verschillende omgevingen',
                        rol2: 'Verschillende rollen',
                        exampleText: 'Denk bijvoorbeeld aan een leraar Management & Organisatie die daarnaast ook een accountantskantoor heeft.',
                        imgUrl: require('../../assets/images/docent-ondernemer-100.png'),
                        quote: 'De reden waarom ik het doe, is omdat ik een vakman ben. Ik wil die passie die ik heb voor mijn vak overbrengen.',
                    }
                ],
                selectedTypeIndex: 1,
                showNextButton: false
            }
        },
        computed: {
            exampleText() {
                return this.types[this.selectedTypeIndex].exampleText;
            },
            firstBaanClass() {
                return { 'job-combination__image--active': this.types[this.selectedTypeIndex].showBaan1 === true};
            },
            schoolClass() {
                return { 'job-combination__image--active': this.types[this.selectedTypeIndex].isSchool === true};
            },
            bedrijfClass() {
                return { 'job-combination__image--active': this.types[this.selectedTypeIndex].isSchool === false};
            },
            docentClass() {
                return { 'job-combination__image--active': this.types[this.selectedTypeIndex].isDocent === true};
            },
            notDocentClass() {
                return { 'job-combination__image--active': this.types[this.selectedTypeIndex].isDocent === false};
            },
            baan2() {
                return this.types[this.selectedTypeIndex].baan2;
            },
            rol2() {
                return this.types[this.selectedTypeIndex].rol2;
            },
            omgeving2() {
                return this.types[this.selectedTypeIndex].omgeving2;
            }
        },
        methods: {
            selectType(index) {
                this.selectedTypeIndex = index;
                if (index === 4) {
                    this.showNextButton = true;
                }
            }
        },
        components: {
            quote
        }
    }

</script>



// WEBPACK FOOTER //
// page-soorten.vue?b55063e8